import { getProps } from "@components-system";
import { createRootieComponent } from "../_shared";
import { FormProvider } from "../forms/provider";
import { Toolbar } from '@components-common/toolbar';

export const FormComponent = (props: any) => {
  const normProps = getProps(props);
  const finalProps = {
    id: props.id,
    ...normProps,
    element: normProps.empty ?? {},
  }
  return createRootieComponent({Component:props.Component,props:finalProps} as any);
}

export const FormContainer = (props: any) => {
    const {
      mode,
      toolbar,
      form
    } = props;
    const formComponent = mode === "create"
      ? <FormProvider>
          <FormComponent {...form} />
        </FormProvider>
      :  <FormProvider>
      <FormComponent {...form} />
    </FormProvider>
    return  <>
      <Toolbar {...toolbar}></Toolbar>
      {formComponent}
    </>;
}
